export default class cttqSentry {
  constructor() {}
  static init(options) {
    return
  }
}